import api from './api';

export interface VersionInfo {
  status: string;
  app: string;
  version: string;
  commit_sha?: string;
  build_date?: string;
  alembic_revision?: string;
  github_repo_url?: string;
  components?: { backend: string; database: string };
}

export const getVersionInfo = async (): Promise<VersionInfo> => {
  const res = await api.get<VersionInfo>('/health');
  return res.data;
};
